import { useSearchParams } from "react-router-dom";
import TrackedList, { useListFilters } from "../TrackedList";
import { useCustomer } from "./CustomerLayout";

/**
 * One customer's tracked items.
 *
 * Tracked only — the suggestions live on the Report tab, beside the run
 * they came from. A suggestion belongs to a report and a tracked item
 * belongs to the customer (invariant 30), and showing both here would mean
 * two "track" buttons for one thing on one page.
 */
export default function CustomerActions() {
  const { customer } = useCustomer();
  const [params, setParams] = useSearchParams();
  const filters = useListFilters(params, (p) => setParams(p, { replace: true }));

  return (
    <>
      <p className="sub">
        Work somebody owns for {customer.display_name}. Resolved items stay —
        they are the record of what was done.
      </p>
      <TrackedList customer={customer.name} {...filters} />
    </>
  );
}
